/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowRoundTimeForwardIcon20Light = forwardRef('ArrowRoundTimeForwardIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M13.263 3.807a7 7 0 1 0 3.22 8.834.5.5 0 0 1 .926.377A8 8 0 1 1 17 6.127V2.748a.5.5 0 0 1 1 0V7.5a.5.5 0 0 1-.5.5H13a.5.5 0 0 1 0-1h3.325a7 7 0 0 0-3.062-3.193Z" })));
});
